import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgKibana = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-kibana';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M6.24 11.5v8.26h13.564l-.024-.35c-.081-1.168-.153-1.674-.345-2.43-.401-1.582-1.132-3.089-2.074-4.28-.86-1.086-2.065-2.075-3.241-2.66a10 10 0 0 1-.353-.181c-.007-.007 1.334-1.483 2.98-3.28a352 352 0 0 0 3.006-3.304c.008-.02-2.871-.035-6.75-.035H6.24zm9.977-6.57c-.941 1.047-3.96 4.321-3.999 4.336-.028.011-.255-.026-.504-.082a13 13 0 0 0-3.264-.283l-.69.028V4.76h8.609zm-6.114 5.514c.24.024.552.064.692.09l.255.046-1.609 1.76-1.645 1.798c-.021.022-.036-.738-.036-1.828v-1.865l.17-.016c.391-.035 1.768-.026 2.173.015m3.164.854A8.7 8.7 0 0 1 14.9 12.32a11.7 11.7 0 0 1 1.395 1.454 10.2 10.2 0 0 1 1.865 4.45c0 .009-2.34.016-5.201.016h-5.2l.01-.933.011-.932 2.44-2.667c1.342-1.467 2.456-2.668 2.475-2.668s.276.116.572.258"
    })
  }));
});
export default SvgKibana;